import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { Sparkles } from 'lucide-react';
import { useT } from '../lib/i18n.js';
import { useSession } from '../stores/session.js';

/**
 * Krok D1 body 1 a 3, prekresleno UXK1 bod 1 — PRUH „UKAZKOVA DATA" A
 * PRUVODCE DEMEM.
 *
 * Pruh se ukazuje JEN v ukazkove kancelari a jen podle serveru
 * (`GET /api/me` → `flags.demo`, zdroj `isDemoTenant` v `@reos/identity`).
 * Tentyz zdroj pravdy odesilani na serveru ZAKAZUJE — proto pruh nemuze
 * tvrdit neco jineho, nez co server dela. Zadna cookie, adresa ani jmeno
 * kancelare se na to neptaji.
 *
 * UXK1: do tohoto kroku to byla velka karta (`rh-v4-guide`) NAD nadpisem
 * stranky (audit `REOS-UX-AUDIT-CLAUDE-2026-10-09.md` bod 1). Misto ni je
 * tenky JEDNORADKOVY pruh (`rh-a2-demobar`) — text + odkaz „Průvodce" —
 * ktery shell kresli v obsahu POD hlavickou stranky (`PageHead` portaluje do
 * `headSlot` pred `.rh-a2-content`, viz `admin-shell.tsx`), takze uz nikdy
 * nestoji nad nadpisem. Na mobilu CSS (`admin-v2.css`) schova podtext, aby
 * radek nepresahl jeden radek.
 *
 * Pruvodce je 5 kroku pribehu ze zadani (najdu problem → vyresim ho → predam
 * klientovi podklady), skryty dokud se neklikne na „Prievodce". ROZHODNUTI
 * D1-3: kroky vedou na OBRAZOVKY, ne na konkretni zakazky.
 */

interface DemoStep {
  readonly id: string;
  readonly href: string;
}

/** Poradi ze zadani D1 bod 3. */
const DEMO_STEPS: readonly DemoStep[] = [
  { id: 'case', href: '/zakazky' },
  { id: 'unknown', href: '/k-doplneni' },
  { id: 'task', href: '/ukoly' },
  { id: 'report', href: '/smlouvy' },
  { id: 'invoice', href: '/fakturace' },
];

export function DemoBanner(): React.JSX.Element | null {
  const t = useT();
  const demo = useSession((s) => s.demo);
  /*
   * Krok DEMO7 bod 1: na VEREJNEM demu (`demo.maklerov.cz`) se data kazdou
   * hodinu vraceji do puvodniho stavu — a navstevnik to musi vedet DRIV, nez
   * si tam neco rozpracuje. Na preview (`demo` bez `publicDemo`) se nic
   * neresetuje, takze by tenhle slib byl lez; proto dva texty a jedna
   * podminka ze serveru, ne jedna veta pro oboje.
   */
  const publicDemo = useSession((s) => s.publicDemo);
  const [open, setOpen] = React.useState(false);

  if (!demo) return null;

  return (
    <section className="rh-a2-demobar" data-testid="demo-banner" aria-labelledby="demo-banner-title">
      <span className="rh-a2-demobar__row">
        <span className="rh-a2-ico rh-a2-ico--sm" aria-hidden="true">
          <Sparkles size={14} strokeWidth={2.2} />
        </span>
        <span className="rh-a2-demobar__text">
          <strong id="demo-banner-title">
            {t(publicDemo ? 'webAdmin.demoMode.bannerPublic' : 'webAdmin.demoMode.banner')}
          </strong>{' '}
          <span className="rh-a2-demobar__hint" data-testid="demo-banner-hint">
            {t(publicDemo ? 'webAdmin.demoMode.bannerPublicHint' : 'webAdmin.demoMode.bannerHint')}
          </span>
        </span>
        <button
          type="button"
          className="rh-a2-demobar__toggle"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          data-testid="demo-tour-toggle"
        >
          {open ? t('webAdmin.demoMode.tourClose') : t('webAdmin.demoMode.tourOpen')}
        </button>
      </span>
      {open ? (
        <div className="rh-a2-demobar__panel">
          <p className="rh-a2-demobar__intro" data-testid="demo-tour-title">
            {t('webAdmin.demoMode.tourTitle')}
          </p>
          <ol className="rh-a2-demobar__steps" data-testid="demo-tour-steps">
            {DEMO_STEPS.map((step, index) => (
              <li key={step.id} className="rh-a2-demobar__step" data-testid={`demo-tour-step-${step.id}`}>
                <Link to={step.href} className="rh-a2-link" onClick={() => setOpen(false)}>
                  {`${String(index + 1)}. ${t(`webAdmin.demoMode.steps.${step.id}.title` as 'webAdmin.demoMode.steps.case.title')}`}
                </Link>
                <span className="rh-a2-demobar__stepwhy">
                  {t(`webAdmin.demoMode.steps.${step.id}.hint` as 'webAdmin.demoMode.steps.case.hint')}
                </span>
              </li>
            ))}
          </ol>
        </div>
      ) : null}
    </section>
  );
}
